/*
  * This is the controller for the cancelling a job match meeting.
 */
var CancelJobMatchMeetingController = /** @class */ (function () {
    /*@ngInject*/
    function CancelJobMatchMeetingController($rootScope, jobMatchService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.jobMatchService = jobMatchService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    CancelJobMatchMeetingController.prototype.$onInit = function () {
        //variables
        this.scheduleData = {
            isCompany: true,
            jobMatchId: '',
            note: '',
            externalNote: '',
            emailAddress: '',
            firstName: '',
            lastName: '',
            role: '',
            department: '',
            company: '',
            startDateTime: '',
            endDateTime: ''
        };
        this.itemDisplayLabel = '';
        this.usersListLabel = '';
        this.cancelLabel = '';
        this.chosenMeeting = '';
        this.meetingsList = [];
        this.externalNotesAction = {};
        this.startDate = '';
        this.startTime = '';
        this.endDate = '';
        this.endTime = '';
        //flags
        this.savingFlag = false;
        this.showFormFlag = false;
        this.loadingFlag = false;
        this.cancellableMeetingsExistFlag = false;
        this.isCorporateFlag = this.$rootScope.userDetails.company.companyType == 'Corporation';
        this.isExternalRequisition = !this.isCorporateFlag;
        this.scheduleData.company = this.$rootScope.userDetails.company.companyId;
        switch (this.itemType) {
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.usersListLabel = 'Select Phone Screen';
                this.cancelLabel = 'Cancel Phone Screen';
                this.noCancellableMeetingsLabel = "No 'Scheduled' Phone Screens are available to cancel !";
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.usersListLabel = 'Select Interview';
                this.cancelLabel = 'Cancel Interview';
                this.noCancellableMeetingsLabel = "No 'Scheduled' Interviews are available to cancel !";
                break;
        }
        this._initializeDateAndTimePickers();
        this.getScheduledItems();
    };
    CancelJobMatchMeetingController.prototype._initializeDateAndTimePickers = function () {
        $(document).ready(function () {
            var currentDate = new Date();
            $('#jobMatchScheduleStartDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true,
                enableOnReadonly: false
            });
            $('#jobMatchScheduleEndDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true,
                enableOnReadonly: false
            });
            $('#jobMatchScheduleStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:00 AM'
            });
            $('#jobMatchScheduleEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:30 AM'
            });
        });
    };
    CancelJobMatchMeetingController.prototype.getScheduledItems = function () {
        var _this = this;
        this.loadingFlag = true;
        var loggedInUserId = null;
        if (this.itemType == 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.$rootScope.userDetails.company.companyId, loggedInUserId, false, function (data) {
                _this.loadingFlag = false;
                _this.meetingsList = _this._getMeetingsList(data);
            }, function (error) {
                _this.loadingFlag = false;
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.$rootScope.userDetails.company.companyId, loggedInUserId, false, function (data) {
                _this.loadingFlag = false;
                _this.meetingsList = _this._getMeetingsList(data);
            }, function (error) {
                _this.loadingFlag = false;
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    };
    CancelJobMatchMeetingController.prototype._getMeetingsList = function (response) {
        var _this = this;
        var meetingsList = [];
        var workflowStep = this.itemType == 'phoneScreen' ? 'ps' : 'in';
        angular.forEach(response, function (meetingDetails, key) {
            var meeting = {};
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = _this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            meeting.createdByCompanyId = meetingDetails.company;
            meeting.isCreatedByClient = meeting.createdByCompanyId !== null && meeting.createdByCompanyId !== _this.scheduleData.company && !_this.isCorporateFlag;
            //let currentDateTime = new Date();
            var startDateTime = new Date(meetingDetails.meetingStartTime);
            var endDateTime = new Date(meetingDetails.meetingEndTime);
            switch (meeting.status) {
                case 'SCHEDULED':
                    meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    _this.cancellableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'fas fa-clock meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    _this.cancellableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fas fa-hourglass-half meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = false;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = false;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTime = moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).format("hh:mm a )");
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, function (meetingUser, k) {
                var user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                user.isPoc = meetingUser.isPoc;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                meeting.userList.push(user);
                if (_this.isSharedRequisition && !_this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            // meeting.label = user.userName + ' - ' + meeting.scheduledTime;
            meetingsList.push(meeting);
        });
        return meetingsList;
    };
    CancelJobMatchMeetingController.prototype.cancelMeeting = function () {
        var _this = this;
        if (!this.cancelForm.$invalid) {
            this.savingFlag = true;
            var meetingObject = {
                companyId: this.scheduleData.company,
                note: this.scheduleData.note,
                externalNote: this.scheduleData.externalNote
            };
            this.jobMatchService.cancelMeeting(this.chosenMeeting.id, meetingObject, function (data) {
                _this.savingFlag = false;
                if (!_.isUndefined(_this.saveCallback)) {
                    _this.saveCallback();
                }
            }, function (error) {
                _this.savingFlag = false;
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    };
    CancelJobMatchMeetingController.prototype.meetingChanged = function () {
        var _this = this;
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.viewMode = this.chosenMeeting.isCreatedByClient;
        this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, function (data) {
            var participant = data.participants[0];
            _this.scheduleData.firstName = participant.firstName;
            _this.scheduleData.lastName = participant.lastName;
            _this.scheduleData.emailAddress = participant.email;
            _this.scheduleData.role = participant.role;
            _this.scheduleData.department = participant.department;
            _this.scheduleData.note = data.note;
            _this.scheduleData.externalNote = data.externalNote;
            if (_.isNull(_this.scheduleData.department)) {
                _this.scheduleData.department = '-';
            }
            else if (_this.scheduleData.department.toString().trim() == '') {
                _this.scheduleData.department = '-';
            }
            var startDateTime = new Date(data.startTime);
            var endDateTime = new Date(data.endTime);
            $("#jobMatchScheduleStartDate").datepicker("setDate", startDateTime);
            $("#jobMatchScheduleEndDate").datepicker("setDate", endDateTime);
            $('#jobMatchScheduleStartTime').timepicker("setTime", startDateTime);
            $('#jobMatchScheduleEndTime').timepicker("setTime", endDateTime);
            _this.loadingFlag = false;
            _this.showFormFlag = true;
        }, function (error) {
            _this.loadingFlag = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CancelJobMatchMeetingController.prototype.onInternalNoteChanged = function () {
        this.scheduleData.externalNote = this.scheduleData.note;
    };
    CancelJobMatchMeetingController.prototype.onExternalNoteChange = function (event) {
        this.scheduleData.externalNote = event.externalNote;
    };
    CancelJobMatchMeetingController.prototype.onCopyNoteChange = function (event) {
        this.copyNote = event.copyNote;
    };
    CancelJobMatchMeetingController.prototype.receiveFormalizedComment = function (event) {
        this.scheduleData.note = event;
        this.onInternalNoteChanged();
    };
    CancelJobMatchMeetingController.prototype.onVoiceTranscript = function (transcript) {
        if (this.scheduleData.note) {
            this.scheduleData.note += ' ' + transcript;
        }
        else {
            this.scheduleData.note = transcript;
        }
        this.onInternalNoteChanged();
    };
    return CancelJobMatchMeetingController;
}());
CancelJobMatchMeetingController.$inject = ['$rootScope', 'jobMatchService', 'meetingService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './cancel-job-match-meeting.html;
import * as TEMPLATE from 'raw-loader!./cancel-job-match-meeting.html';
export var CancelJobMatchMeetingComponent = {
    selector: 'cancelJobMatchMeeting',
    component: {
        bindings: {
            jobMatchObject: '<',
            isSharedRequisition: '<',
            saveCallback: '&',
            itemType: '@',
            jobMatchId: '@',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: CancelJobMatchMeetingController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/cancelJobMatchMeeting/cancel-job-match-meeting.html'
    }
};
//# sourceMappingURL=cancel-job-match-meeting.component.js.map